import useThemeHook from "../hooks/useThemeHook";
import { THEME_COLORS } from "../themes/DarkLight";
const Global = ({ children }) => {
  const theme = useThemeHook();

  return (
    <div
      style={{
        minHeight: "100%",
        backgroundColor: THEME_COLORS[theme].full_theme,
      }}
    >
      {children}
    </div>
  );
};

export default Global;
